module.exports = __webpack_public_path__ + "static/img/アセット 31@2x.3c45768.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meal_history/アセット 31@2x.png
// module id = v6vY
// module chunks = 1